import axios from "axios";
import Qs from "qs";
import { getUserToken } from "./user";

// 创建axios实例
axios.defaults.withCredentials = true;
const service = axios.create({

  // baseURL: 'https://aigc-safe.xinhuanet.com/', 
  baseURL: '',
  headers: {
    "token": localStorage.getItem("aitoken"),
  },
  // timeout:300000, // 请求超时时间
  withCredentials: false,
});
// request拦截器
service.interceptors.request.use(
  (config) => {
    if (config.formdata) {
    
      config.data =  Qs.stringify(config.data);

      (config.headers["Content-Type"] = "application/x-www-form-urlencoded");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
      
      // return config;
    }else {
      config.data = JSON.stringify(config.data);
      config.headers["Content-Type"] = "application/json;charset=UTF-8";
    }
    if(getUserToken()) {
      config.headers["token"] = getUserToken()
      config.headers["device-token"] = getUserToken()
    }else{
      config.headers["token"] = ""
      config.headers["device-token"] = ""
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);
// response 拦截器
service.interceptors.response.use(
  (response) => {

    const res = response.data;    
    if (res.code == 200) {
      return Promise.resolve(response.data);
    }
    else {
      if(res.msg=='没有检测资格'){
        localStorage.removeItem('aitoken')
        window.location.href='/'
      }
        if (res.code) {
        response.data.message =res.code
      }
      return Promise.reject(response.data);
    }
  },
  (err) => {
    if (err && err.response) {
      
      return Promise.reject(err.response)
    }
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js